export default [
    {
        path: 'agendamento-retroativo',
        component: () => import(
            /* webpackChunkName: 'exame-imagem-agendamento-retroativo' */
            '@/views/exame-imagem/agendamento-retroativo/Index'
        ),
        redirect: 'agendamento-retroativo/index',
        children: [
            {
                name: 'exame-imagem-agendamento-retroativo-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-agendamento-retroativo' */
                    '@/views/exame-imagem/agendamento-retroativo/List.vue'
                ),
            },
            {
                name: 'exame-imagem-agendamento-retroativo-create',
                path: 'create/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-agendamento-retroativo' */
                    '@/views/exame-imagem/agendamento-retroativo/Form.vue'
                ),
            },
        ],
    },
]